class ProductReviewsSidebar {
  constructor(buttonSelector = '.open-reviews-sidebar') {
    this.sidebar = document.querySelector('.wc-product-reviews-modal');

    if (!this.sidebar) return;

    this.initTriggers(buttonSelector);
    this.initSidebarEvents();
  }

  initTriggers(selector) {
    document.querySelectorAll(selector).forEach(button => {
      button.addEventListener('click', e => {

        e.preventDefault();
        this.openSidebar();
      });
    });
  }

  openSidebar() {
    this.sidebar.classList.add('is-open');
    document.body.classList.add('sidebar-open');
  }

  closeSidebar() {
    this.sidebar.classList.remove('is-open');
    document.body.classList.remove('sidebar-open');
  }

  initSidebarEvents() {
    const overlay = this.sidebar.querySelector('.wc-product-reviews-modal__overlay');
    const closeBtn = this.sidebar.querySelector('.wc-product-reviews-modal__close');
    const cancelBtn = this.sidebar.querySelector('.close-modal');
    const starsContainer = this.sidebar.querySelector('.wc-product-reviews-modal__stars');
    const stars = starsContainer?.querySelectorAll('.star') || [];
    const form = this.sidebar.querySelector('.wc-product-reviews-modal__form');

    [overlay, closeBtn, cancelBtn].forEach(el => {
      el?.addEventListener('click', () => this.closeSidebar());
    });

    stars.forEach(star => {
      star.addEventListener('click', () => {
        const sel = parseInt(star.dataset.value, 10);
        starsContainer.dataset.selected = sel;
        stars.forEach(s => {
          const val = parseInt(s.dataset.value, 10);
          const path = s.querySelector('path');
          path.setAttribute('fill', val <= sel ? '#FBB03B' : '#ccc');
        });
      });
    });

    form?.addEventListener('submit', e => {
      e.preventDefault();
      this.submitReview(form);
    });
  }

  async submitReview(form) {
    const starsContainer = form.querySelector('.wc-product-reviews-modal__stars');
    const rating = starsContainer.dataset.selected;
    const author = form.querySelector('[name="author"]').value.trim();
    const comment = form.querySelector('[name="comment"]').value.trim();
    const productId = this.sidebar.dataset.productId;

    if (!author || !comment || !rating || rating < 1) {
      alert('Uzupełnij wszystkie pola i wybierz ocenę.');
      return;
    }

    const fd = new FormData();
    fd.append('action', 'submit_product_review_ajax');
    fd.append('nonce', ajax.nonce);
    fd.append('product_id', productId);
    fd.append('author', author);
    fd.append('comment', comment);
    fd.append('rating', rating);

    try {
      const res = await fetch(window.ajax.url, { method: 'POST', body: fd });
      const result = await res.json();

      if (result.success) {
        alert('Dziękujemy za opinię!');
        form.reset();
        starsContainer.dataset.selected = 0;
        form.querySelectorAll('.wc-product-reviews-modal__form__stars .star path')
          .forEach(path => path.setAttribute('fill', '#ccc'));
      } else {
        alert(result.data || 'Wystąpił błąd.');
      }
    } catch (err) {
      console.error('Błąd wysyłania opinii:', err);
      alert('Nie udało się zapisać opinii.');
    }
  }
}

new ProductReviewsSidebar();
